/**
 * 掩码处理昵称 (例如: 'tommyage' -> 'tom***age')
 * 参考规则：保留前3位和后3位，中间用 *** 替换
 * 如果长度不足，则根据实际情况调整保留位数
 */
export function maskNickname(nickname: string): string {
  if (!nickname) return '-'

  const len = nickname.length
  if (len <= 2) return nickname // 太短不处理
  if (len <= 5) {
    return `${nickname[0]}***${nickname[len - 1]}`
  }

  const start = nickname.slice(0, 3)
  const end = nickname.slice(-3)
  return `${start}***${end}`
}
